import { X } from 'lucide-react';
import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

export const Modal = ({ title, onClose, children, footer, size = '', hideClose = false }) => {
  // Tracks whether the mouse press STARTED on the overlay. Without this, a click-drag
  // that begins inside an input (e.g. selecting a number) and releases over the overlay
  // fires a click on the overlay and closes the modal, losing everything typed.
  const pressStartedOnOverlay = useRef(false);

  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onClose]);

  return createPortal(
    <div
      className="modal-overlay"
      onMouseDown={(e) => { pressStartedOnOverlay.current = e.target === e.currentTarget; }}
      onClick={(e) => {
        const shouldClose = e.target === e.currentTarget && pressStartedOnOverlay.current;
        pressStartedOnOverlay.current = false;
        if (shouldClose) onClose?.();
      }}
    >
      <div className={`modal${size ? ' modal-' + size : ''}`}>
        <div className="modal-header">
          <span className="modal-title">{title}</span>
          {!hideClose && (
            <button className="close-btn" onClick={onClose}><X size={14} /></button>
          )}
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>,
    document.body
  );
};